import { useMembersContext } from '@/contexts/membersContext';
import { UserAppointmentFull } from '@/pages/members/types';
import { JoinVideoAppointmentParams, LeaveVideoAppointmentParams } from '@/types/videoSessions';
import ajax from '@/utils/ajax';

export const appointmentsRepository = {
  async getAppointment({ host, id }: { host: string; id: string }): Promise<UserAppointmentFull> {
    const path = `/api/v3/appointments/${id}`;
    const response = await ajax.get({
      url: `${host}${path}`,
      config: {
        withCredentials: true
      }
    });

    return response.data;
  },

  async joinVideoAppointment({
    host,
    data
  }: {
    host: string;
    data: JoinVideoAppointmentParams;
  }): Promise<void> {
    const path = `/api/appointments/video_sessions/join/`;
    await ajax.post({
      url: `${host}${path}`,
      data,
      config: {
        withCredentials: true,
        withXSRFToken: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken'
      }
    });
  },

  async leaveVideoAppointment({
    host,
    data
  }: {
    host: string;
    data: LeaveVideoAppointmentParams;
  }): Promise<void> {
    const path = `/api/appointments/video_sessions/leave/`;
    await ajax.post({
      url: `${host}${path}`,
      data,
      config: {
        withCredentials: true,
        withXSRFToken: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken'
      }
    });
  }
};

const AppointmentsRepository = () => {
  const { host } = useMembersContext();

  return {
    async getAppointment(id: string): Promise<UserAppointmentFull> {
      return appointmentsRepository.getAppointment({ host, id });
    },

    async joinVideoAppointment(data: JoinVideoAppointmentParams): Promise<void> {
      return appointmentsRepository.joinVideoAppointment({ host, data });
    },

    async leaveVideoAppointment(data: LeaveVideoAppointmentParams): Promise<void> {
      return appointmentsRepository.leaveVideoAppointment({ host, data });
    }
  };
};

export default AppointmentsRepository;
